module.exports = __webpack_public_path__ + "static/media/bg-footer.6985fba8.png";